import type { CommonResponse } from '@/utils/request';
import { Request } from '@/utils/request';

export enum ERealtimeRole {
  USER = 'user',
  ASSISTANT = 'assistant',
  SYSTEM = 'system'
}

export enum ERealtimeType {
  MESSAGE = 'message',
  FUNCTION_CALL = 'function_call',
  FUNCTION_CALL_OUTPUT = 'function_call_output'
}

export enum ERealtimeMsgItemContentType {
  INPUT_TEXT = 'input_text',
  INPUT = 'input',
  INPUT_AUDIO = 'input_audio'
}

interface IRealtimeMessages {
  item: IRealtimeMsgItem;
}

export interface IRealtimeMsgItem {
  id: string;
  type: ERealtimeType;
  role: ERealtimeRole;
  content: IRealtimeMsgItemContent[];
}

interface IRealtimeMsgItemContent {
  type: ERealtimeMsgItemContentType;
  text: string;
}

interface ICreateRealtimeSessionResponse {
  clientSecretValue: string;
  model: string;
  processedMessages: IRealtimeMessages[];
}

export const createRealtimeSession = (sessionId: string, chatType?: 'COLD_START' | 'NORMAL') => {
  return Request<CommonResponse<ICreateRealtimeSessionResponse>>({
    url: '/rest/os/realtime/create/session',
    method: 'get',
    params: { sessionId, chatType }
  });
};

interface IExecuteFunctionParams {
  wsId?: string;
  sessionId?: string;
  messageId?: string;
  functionName: string;
  args: Record<string, any>;
  functionCallId: string;
}

interface IExecuteFunctionResponse {
  output: string;
  success: boolean;
}

export const executeFunction = (data: IExecuteFunctionParams) => {
  return Request<CommonResponse<IExecuteFunctionResponse>>({
    url: '/rest/os/realtime/execute/function',
    method: 'post',
    data
  });
};

interface ISaveContentReq {
  wsId: string;
  sessionId: string;
  messageId: string;
  sender: 'umm' | 'client';
  message: string;
}

export const saveContent = (data: ISaveContentReq) => {
  return Request<CommonResponse<IRealtimeMsgItem>>({
    url: '/rest/os/realtime/save/conversation',
    method: 'post',
    data
  });
};

export const batchSaveContent = (data: { msgList: ISaveContentReq[] }) => {
  return Request<CommonResponse<IRealtimeMsgItem>>({
    url: '/rest/os/realtime/save/batch/conversation',
    method: 'post',
    data
  });
};

interface IColdStartStage {
  currentRound: number;
  totalRound: number;
}

export const checkColdStartUpRealtimeStage = (data: { sessionId: string; message: string }) => {
  return Request<CommonResponse<IColdStartStage>>({
    url: '/rest/os/realtime/check/stage',
    method: 'post',
    data
  });
};
